import baseApi from 'domain/api/baseApi'
import { combineReducers } from 'redux'
import { reducers } from 'domain'

export default combineReducers({
  ...reducers,
  [baseApi.reducerPath]: baseApi.reducer,
})
